import { createAction } from "@ngrx/store";
import { ILevel } from "../../models/user/level.model";

export const setLevels = createAction(
  '[Level] Set Levels',
  (levels: ILevel[]) => ({levels})
);
